import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Type_ILocationTimelineEvent } from '../Type/Type.hive'

export function IDB_locationTimelineEventRead(id: number) {
    return IDB_rowRead<Type_ILocationTimelineEvent>(IDB_globalDb, 'location_timeline_events', id)
}

export function IDB_locationTimelineEventsDelete(ids: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'location_timeline_events', ids)
}

export function IDB_locationTimelineEventsReadAll() {
    return IDB_rowsReadAll<Type_ILocationTimelineEvent>(IDB_globalDb, 'location_timeline_events')
}

export function IDB_locationTimelineEventsWrite(locationTimelineEvents: Type_ILocationTimelineEvent[]) {
    return IDB_rowsWrite(IDB_globalDb, 'location_timeline_events', locationTimelineEvents)
}
